import * as React from 'react'
import IconType from './iconType'

const MidServicesIcon = (props: IconType) => {

  return (
    <svg
      className={`${props.className}`}
      height={props.h}
      width={props.w}
      viewBox="0 0 448 512"
      >
      <path d="M0 80C0 53.49 21.49 32 48 32H144C170.5 32 192 53.49 192 80V240C192 266.5 170.5 288 144 288H48C21.49 288 0 266.5 0 240V80zM48 240H144V80H48V240zM256 272C256 245.5 277.5 224 304 224H400C426.5 224 448 245.5 448 272V432C448 458.5 426.5 480 400 480H304C277.5 480 256 458.5 256 432V272zM304 432H400V272H304V432zM144 320C170.5 320 192 341.5 192 368V432C192 458.5 170.5 480 144 480H48C21.49 480 0 458.5 0 432V368C0 341.5 21.49 320 48 320H144zM144 368H48V432H144V368zM256 80C256 53.49 277.5 32 304 32H400C426.5 32 448 53.49 448 80V144C448 170.5 426.5 192 400 192H304C277.5 192 256 170.5 256 144V80zM304 144H400V80H304V144z"
      />
    </svg>
  )
}

export default MidServicesIcon
